<div class="component-card mt-0 mt-md-5">
  <!-- العنوان والوصف -->
  <div>
    <h1 class="text-center">
      <span class="strok-text">{{ data.title.split(" ")[0] }}</span
      >{{ data.title.split(" ")[1] }}
    </h1>
    <h5 class="mb-4" [innerHTML]="data.description"></h5>
  </div>

  <div class="row justify-content-center">
    <div
      *ngFor="let member of data.team"
      class="col-6 col-md-4 col-lg-3 member text-center mb-4"
    >
      <img
        class="person-img img-fluid"
        [src]="member.imagesrc"
        [alt]="member.name + ' ' + member.position"
      />
      <h4 class="name mt-1">{{ member.name }}</h4>
      <h6 class="position">{{ member.position }}</h6>
    </div>
  </div>
</div>
